// extracted by mini-css-extract-plugin
export default {"mainHeader":"UserDashboard_mainHeader__Kzkok","card":"UserDashboard_card__L1ORN"};